import { useEffect } from "react";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";

export const followupReminderPostApi = async (appointmentId, date) => {
  const payload = {
    id: appointmentId,
    follow_up_date: date,
  };

  const res = await afterLoginApiAxios({
    method: "post",
    url: "api/v1/appointments/followup_reminder",
    data: payload,
    headers: {
      authorization: localStorage.getItem("id_token"),
    },
  });

  if (res.data?.statusCode === 200) {
    return { res: res.data?.message };
  } else if (res.data?.statusCode === 400) {
    return { error: res.data?.message };
  }
  return [null, true];
};
